import { useState,useEffect, useRef, useCallback } from "react";
import { Tooltip } from "./utils/Tooltip";
import { FiltroSelect } from "./FiltroSelect";
export const Filtro = ({ nombreFiltros,
    seleccionDefault,
    data,
    setOpcionesSeleccionadas,
    filtroEspecial,
    nomFiltroEspecial,
    setFiltroEspecial,
    opcionesFiltroEspecial
}) => {
    const [ mostrarFiltro, setMostrarFiltro ] = useState(false);
    const contenedorFiltroRef = useRef(null);
    const iconoFiltroRef =useRef(null);
    const classNameSelect = "h-[34px] dark:text-white rounded w-full bg-zinc-800  dark:bg-gray-800 focus:outline-none focus:ring-1 focus:ring-blue-500";
    const [ claves, setClaves] = useState([])
    const [ datosUnicos, setDatosUnicos ] = useState([])
    useEffect(() => {
        //Se oculte automaticamente cuando no este el focus dentro del contenedor de select
        document.addEventListener('mousedown',(event) =>{
            if(
                mostrarFiltro && contenedorFiltroRef.current &&
                !contenedorFiltroRef.current.contains(event.target) && 
                !iconoFiltroRef.current.contains(event.target)
            ){
                setMostrarFiltro(false)
            }
        })
    },[mostrarFiltro])

    useEffect(()=> {
        const transformarDataPorCadaKey = (data) => { // Funcion que sirve para poder estructurar los datos por cada key del objeto de un arreglo
            return data.reduce((acumulador,objeto) => {
                Object.keys(objeto).forEach(key => {
                    if(nombreFiltros.includes(key)){
                        if(!acumulador.hasOwnProperty(key)){
                            acumulador[key] = [];
                        }
                        acumulador[key].push(objeto[key]);
                    }
                })
                return acumulador; 
            },{})
        }
        const nuevaDataTotal = transformarDataPorCadaKey(data) // Se obtiene en la variable los datos estructurados
    
        const dataUnica = Object.entries(nuevaDataTotal).reduce((acumulador, [clave,arreglo]) => { //Se hace una limpieza de los datos, quitando los vacios y eliminando los datos repetidos
            const valoresFiltrados = arreglo.filter(valor => valor !== '');
            if (valoresFiltrados.length > 0) {
                acumulador[clave] = [...new Set(valoresFiltrados)];
            }
            return acumulador;
        },{})
        setDatosUnicos(dataUnica)
        setClaves(Object.keys(dataUnica))
        
    },[data])
    // const claves = Object.keys(datosUnicos);
    
    const primeraLetraMayuscula = (palabra) => {
        if (typeof palabra !== 'string' || palabra.length === 0) {
            return palabra;
        }
        // Convertir la primera letra a mayúscula y concatenar el resto de la palabra
        return palabra.charAt(0).toUpperCase() + palabra.slice(1);
    }

    const modificarTextoFiltro = (texto) => {
        if(texto.toLowerCase().includes('fecha')){
            return  'Fecha ' + texto.split('fecha')[1] 
        }
        else 
            if(texto.toLowerCase().includes('nom') ){
                if(texto.toLowerCase().includes('area') ){
                    return 'Área' + texto.toLowerCase().split('area')[1]
                }
                else{
                    return primeraLetraMayuscula(texto.split('nom' )[1])
                }
            }
        else 
            if(texto.toLowerCase().includes('cod') ){
                return primeraLetraMayuscula(texto)
            }
            else{
                return texto
            }
    }
    
    const editFiltroEspecial = (e) =>{
        setFiltroEspecial(Number(e.target.value))
    }
    const eventoMostrarContenido = () => {
        setMostrarFiltro(prevMostrarFiltro => !prevMostrarFiltro)
    }

    return(
        <section>
            <i 
                ref={iconoFiltroRef}
                className="fas fa-filter cursor-pointer overflow-hidden "
                onClick={eventoMostrarContenido}
                data-tip={'filtro'}
                data-for={'filtro'}
            ></i>
            <Tooltip id={'filtro'}>Filtros</Tooltip>
            <section
                key={'Contenedor_Principal'}
                ref={contenedorFiltroRef}
                className={`${mostrarFiltro ? ' max-h-[600px]  opacity-100 visible '  : ' max-h-0 opacity-0 invisible '}
                bg-zinc-600 text-white max-w-[950px]  min-w-[700px]  transition-all duration-500 ease-out
                    min-h-auto z-50 absolute cs-message-receptor shadow-inner shadow-zinc-800 p-5`}
            >
                {
                    claves.length > 0 && 
                        claves.map((nombre,i) => (
                            <section 
                                className={`w-[50%] w-min-[450px] lg:w-min-[150px] h-[50px] ${(i % 2 ) !== 0 ? 'float-right' : 'float-left'}
                                p-2 flex items-center gap-2 lg:p-1`}
                                key={`${nombre}${i}`}
                            >
                                <label className="w-[40%] min-w-[100px]">{modificarTextoFiltro(nombre)}</label>
                                {
                                    !nombre.toLowerCase().includes('fecha') &&(
                                        <section
                                            className="w-[60%] min-w-[200px]" 
                                            key={'_filtro' + i} 
                                        >
                                            <FiltroSelect
                                                opciones={datosUnicos[nombre]}
                                                selectedDefault={seleccionDefault[i]}
                                                setOpcionesSeleccionadas={setOpcionesSeleccionadas}
                                                indice={i}
                                            ></FiltroSelect>
                                        </section>
                                    )
                                }
                            </section>
                        
                        ))
                    
                }
                
                {
                    filtroEspecial && filtroEspecial.length > 0 &&
                    <div 
                        className={`w-[50%] w-min-[450px] h-[50px] float-left
                        p-2 flex items-center gap-2 ${filtroEspecial.length === 0 ? ' hidden ' : ''}`}
                        key={`filtroEspecial`}
                    >
                        <label className="w-[40%] min-w-[100px]">{nomFiltroEspecial}</label>
                        {
                        
                            <div 
                                className="w-[57%] min-w-[200px]" 
                                key={0}
                            >
                                <select
                                    className={`${classNameSelect}`}
                                    onChange={editFiltroEspecial}
                                >
                                    {
                                        filtroEspecial.length > 0 &&
                                        filtroEspecial.map((data, i) => {
                                            // if(i===0){
                                            //     setFiltroEspecial(data[opcionesFiltroEspecial.cod])
                                            // }
                                            return <option value={data[opcionesFiltroEspecial.cod]}>{data[opcionesFiltroEspecial.nom]}</option>
                                        })
                                    }
                                </select>
                            </div>
                            
                        }
                    </div>
                }
            </section>
               
        </section>
    )
}

